import * as React from 'react';
// Provides a minimal functionality to render components without styles and without runtime errors.

var NoopProvider = function NoopProvider(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
};
export var noopRenderer = {
  registerUsage: function registerUsage() {},
  unregisterUsage: function unregisterUsage() {},
  renderFont: function renderFont() {},
  renderGlobal: function renderGlobal() {},
  renderRule: function renderRule() {
    return '';
  },
  Provider: NoopProvider
};
//# sourceMappingURL=noopRenderer.js.map
